module.exports = __webpack_public_path__ + "static/media/46.f3caca97.png";